import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/platform-content/obligations/')({
    beforeLoad: () => {
        throw redirect({ to: '/admin-console/platform-content/obligations/library', replace: true });
    },
});
